__turbopack_context__.v({
  "deleteIcon": "uploadFile-module-scss-module__gMwXPq__deleteIcon",
  "deleteIconWrapper": "uploadFile-module-scss-module__gMwXPq__deleteIconWrapper",
  "errorMessage": "uploadFile-module-scss-module__gMwXPq__errorMessage",
  "fileItem": "uploadFile-module-scss-module__gMwXPq__fileItem",
  "fileName": "uploadFile-module-scss-module__gMwXPq__fileName",
  "inputUploadContainer": "uploadFile-module-scss-module__gMwXPq__inputUploadContainer",
  "noFileLabel": "uploadFile-module-scss-module__gMwXPq__noFileLabel",
  "uploadContainer": "uploadFile-module-scss-module__gMwXPq__uploadContainer",
  "uploadInput": "uploadFile-module-scss-module__gMwXPq__uploadInput",
  "uploadTitle": "uploadFile-module-scss-module__gMwXPq__uploadTitle",
});
